import { Box, Button, Typography } from '@mui/material'
import styles from './ActionRow.module.scss'
import { actionRowIconOnlySx, actionRowLabelSx, actionRowMainSx } from './actionRowSx.js'

export function ActionRow({
  Icon,
  label,
  trailingIcon: TrailingIcon,
  onClick,
  compact = false,
  plain = false,
  active = false,
  iconOnly = false,
  buttonProps,
}) {
  const rowClass = [
    styles.row,
    compact ? styles.rowCompact : '',
    plain ? styles.rowPlain : '',
    active ? styles.rowActive : '',
    iconOnly ? styles.rowIconOnly : '',
  ]
    .filter(Boolean)
    .join(' ')

  if (iconOnly) {
    return (
      <Button
        type="button"
        variant="text"
        onClick={onClick}
        aria-label={label}
        className={rowClass}
        sx={actionRowIconOnlySx(active)}
        {...buttonProps}
      >
        {Icon ? (
          <Box component="span" className={styles.iconWrap} aria-hidden>
            <Icon className={styles.icon} />
          </Box>
        ) : null}
      </Button>
    )
  }

  return (
    <Button
      type="button"
      variant="text"
      onClick={onClick}
      className={rowClass}
      sx={actionRowMainSx(plain, active)}
      {...buttonProps}
    >
      <Box component="span" className={styles.leading}>
        {Icon ? (
          <Box component="span" className={styles.iconWrap} aria-hidden>
            <Icon className={styles.icon} />
          </Box>
        ) : null}
        <Typography component="span" className={styles.label} sx={actionRowLabelSx}>
          {label}
        </Typography>
      </Box>
      {TrailingIcon ? (
        <Box component="span" className={styles.trailingWrap} aria-hidden>
          <TrailingIcon className={styles.trailingIcon} />
        </Box>
      ) : null}
    </Button>
  )
}

export default ActionRow
